export class Queue {
    // 最大运行数 私有
    #maxRunning;
    // 当前运行数 私有
    #currentRunning = 0;
    // 等待队列
    waitingQueue = [];
    constructor(maxRunning) {
        this.#maxRunning = maxRunning;
    }
    // 当前运行数 只读
    get currentRunning() {
        return this.#currentRunning;
    }
    // 执行事件
    execute(task, resolve, reject) {
        task
            .then((data) => {
            resolve(data);
        })
            .catch((e) => {
            reject(e);
        })
            .finally(() => {
            if (this.waitingQueue.length) {
                const next = this.waitingQueue.shift();
                if (next)
                    this.execute(next.task, next.resolve, next.reject);
                else
                    this.#currentRunning = this.waitingQueue.length;
            }
            else
                this.#currentRunning = this.waitingQueue.length;
        });
    }
    // 运行
    run(task) {
        return new Promise((resolve, reject) => {
            if (this.currentRunning >= this.#maxRunning) {
                const id = `${+new Date()}--${this.waitingQueue.length}`;
                this.waitingQueue.push({ id, task, resolve, reject });
                resolve(id);
            }
            else {
                this.#currentRunning += 1;
                this.execute(task, resolve, reject);
            }
        });
    }
    ;
    // 移除
    remove(id) {
        if (!id)
            return;
        this.waitingQueue = this.waitingQueue.filter(w => w.id !== id);
    }
}
